import { useState, useCallback } from 'react';

let toastId = 0;
let globalToasts = [];
let globalSetToasts = null;

export const useToast = () => {
  const [toasts, setToasts] = useState(globalToasts);
  
  if (!globalSetToasts) {
    globalSetToasts = setToasts;
  }

  const addToast = useCallback((message, type = 'info') => {
    const newToast = {
      id: ++toastId,
      message,
      type
    };
    globalToasts = [...globalToasts, newToast];
    globalSetToasts(globalToasts);
  }, []);

  const removeToast = useCallback((id) => {
    globalToasts = globalToasts.filter(toast => toast.id !== id);
    globalSetToasts(globalToasts);
  }, []);

  return { toasts, addToast, removeToast };
};

export const showToast = (message, type = 'info') => {
  if (globalSetToasts) {
    const newToast = {
      id: ++toastId,
      message,
      type
    };
    globalToasts = [...globalToasts, newToast];
    globalSetToasts(globalToasts);
  }
};